module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_7.d955923c.png";